import config from '@actr/config';
import { ProjectNames } from '@actr/specs/src/project/names';
import { ProjectTypes } from '@actr/specs/src/project/types';
import { ThemeName } from '@actr/specs/src/theme-name';

import { LocalConfig } from './specs';

const baseConfig: LocalConfig = {
  ...config,
  theme: ThemeName.AVIAKASSA_SEO_SITE,
  projectType: ProjectTypes.AK_REDESIGN,
  YM_TrackingID: '85926445',
  project: ProjectNames.V2_SEO,
  rootId: 'aviakassa-v2-seo-app',
  baseLogo: 'https://s.aviakassa.ru/images/logo-ak-v2-square.png',
  hotel: {
    ...config.hotel,
    enablePersistSearchLocation: true,
    enablePersistSearchDate: true,
  }
};

export default baseConfig;
